/**
 * Lenz — Helpers para la product page.
 *
 * v6: Re-ubicar el widget de upsell PickyStory para que aparezca JUSTO ARRIBA
 *     del botón "Agregar al carrito", dentro de la columna .product-info,
 *     no después del producto entero.
 *
 * Ubicación target en el DOM:
 *   .product
 *     └─ safe-sticky.product-info
 *          └─ ...bloques (title, price, accordions, etc.)
 *          └─ .product-info__buy-buttons   ← INSERTAMOS EL SLOT JUSTO ANTES
 *               └─ .shopify-product-form
 *                    └─ buy-buttons
 *                         └─ button "Agregar al carrito"
 *
 * No tocamos el HTML de PickyStory ni su JS — solo movemos el contenedor
 * raíz a otro slot del DOM. Los listeners internos siguen funcionando porque
 * jQuery delega o el código usa selectores absolutos.
 */

(function () {
  'use strict';

  function findSlotTarget() {
    // Preferido: el div hermano del bloque buy-buttons que contiene la
    // sección "Agregar al carrito" en la columna info del producto.
    var buyButtonsBlock = document.querySelector('.product-info__buy-buttons');
    if (buyButtonsBlock && buyButtonsBlock.parentElement) {
      return {
        parent: buyButtonsBlock.parentElement,
        before: buyButtonsBlock,
      };
    }
    // Fallback 1: si no encontramos esa clase, usamos buy-buttons mismo y
    // metemos el slot antes del shopify-product-form que la contiene.
    var form = document.querySelector('.shopify-product-form');
    if (form && form.parentElement) {
      return {
        parent: form.parentElement,
        before: form,
      };
    }
    // Fallback 2: cualquier botón "Agregar al carrito" — subimos al primer
    // wrapper razonable y metemos el slot antes.
    var btn = document.querySelector('buy-buttons');
    if (btn && btn.parentElement) {
      return {
        parent: btn.parentElement,
        before: btn,
      };
    }
    return null;
  }

  function moveWidget() {
    // El widget de PickyStory se monta async. Puede ser <lb-product-page-cross-sell-ew>
    // o un .ppcse / .ppcse-m (mobile). Buscamos cualquiera de los dos como root.
    var widget =
      document.querySelector('lb-product-page-cross-sell-ew') ||
      document.querySelector('.ppcse, .ppcse-m');
    if (!widget) return false;
    if (widget.dataset.lenzMoved === '1') return true;

    var product = document.querySelector('.product');
    if (!product) return false;

    var target = findSlotTarget();
    if (!target) return false;

    // Reusar slot existente si ya está colocado donde queremos.
    var slot = target.parent.querySelector(':scope > .lenz-upsell-slot');
    if (!slot) {
      slot = document.createElement('div');
      slot.className = 'lenz-upsell-slot lenz-upsell-slot--inline';
      target.parent.insertBefore(slot, target.before);
    }

    if (widget.parentElement === slot) {
      widget.dataset.lenzMoved = '1';
      product.classList.add('product--has-lenz-upsell');
      return true;
    }

    slot.appendChild(widget);
    widget.dataset.lenzMoved = '1';
    product.classList.add('product--has-lenz-upsell');
    return true;
  }

  function init() {
    if (moveWidget()) return;
    // El widget puede aparecer después (la app es async). Observamos cambios
    // en el body hasta que lo encontremos. Una vez movido, desconectamos.
    var observer = new MutationObserver(function () {
      if (moveWidget()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Fail-safe: deja de observar tras 15s para no consumir CPU eternamente.
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — ETA en mobile: mover debajo de los métodos de pago.

   En MOBILE puro (< 768px) el ETA se mueve desde .lenz-product-left
   (donde vive en el HTML) a .product-info, insertándolo DESPUÉS
   del último bloque de pagos (.product-info__liquid) y antes del
   HR separador. Así el orden visual queda:
     galería → info (precio, kits, ATC, WhatsApp, Mercado Pago)
             → ETA → HR → descripción

   En TABLET (768-999) y DESKTOP (≥ 1000px) el ETA se queda en su
   posición original en .lenz-product-left, debajo de la galería.
   Esto coincide con el deseo del merchant: en tablet la columna
   izquierda muestra galería + ETA, y la derecha (o el bloque que
   le sigue en single-column) muestra info + ATC.
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  // < 768px = mobile real. >= 768px (tablet + desktop) deja el ETA
  // debajo de la galería en .lenz-product-left.
  var BREAKPOINT = 768;
  var originalParent = null;
  var originalNextSibling = null;
  var isMoved = false;

  function getEta() { return document.getElementById('lenz-product-eta-card'); }

  // Insertar ETA justo antes del HR separador (o antes de la descripción).
  // Eso coloca el ETA después de todos los .product-info__liquid (pagos).
  function getInsertTarget() {
    var hr = document.querySelector('.product-info__separator');
    if (hr && hr.parentElement) return { parent: hr.parentElement, before: hr };
    var desc = document.querySelector('.product-info__description');
    if (desc && desc.parentElement) return { parent: desc.parentElement, before: desc };
    return null;
  }

  function moveToMobile() {
    var eta = getEta();
    if (!eta || isMoved) return;
    var target = getInsertTarget();
    if (!target) return;

    originalParent = eta.parentElement;
    originalNextSibling = eta.nextSibling;

    target.parent.insertBefore(eta, target.before);
    isMoved = true;
  }

  function restoreToDesktop() {
    var eta = getEta();
    if (!eta || !isMoved || !originalParent) return;
    if (originalNextSibling && originalNextSibling.parentElement === originalParent) {
      originalParent.insertBefore(eta, originalNextSibling);
    } else {
      originalParent.appendChild(eta);
    }
    isMoved = false;
  }

  function applyLayout() {
    if (window.innerWidth < BREAKPOINT) { moveToMobile(); } else { restoreToDesktop(); }
  }

  function init() {
    var eta = getEta();
    var hr = document.querySelector('.product-info__separator');
    if (eta && hr) { applyLayout(); return; }
    var obs = new MutationObserver(function () {
      if (getEta() && document.querySelector('.product-info__separator')) {
        obs.disconnect(); applyLayout();
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyLayout, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — En tablet (768-1199px) envolver "Agregar al carrito" y el
   banner de WhatsApp en un contenedor flex para que aparezcan en una
   sola línea (lado a lado).

   El banner de WhatsApp viene de un Shopify App Block externo (NTA-Woo
   Products) que se renderiza como hermano de .product-info__buy-buttons
   dentro de safe-sticky.product-info. Para ponerlos en una sola fila
   sin tocar el theme/app, los envolvemos en un <div class="lenz-atc-wa-row">
   y al CSS le decimos display:flex en tablet.

   En desktop (≥1200), des-envolvemos para devolver
   cada bloque a su posición natural en el flujo del documento.

   v2: Extendido a mobile (<768px) también — en mobile se usa display:grid
   de 2 columnas vía CSS (.lenz-atc-wa-row en @media max-width:767px).
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  // Ahora aplica en mobile + tablet (0-1199px). Solo en desktop (≥1200px)
  // des-envolvemos — en desktop el layout es 2 columnas y el ATC/WA
  // se ven bien cada uno en su fila.
  var WRAP_MAX = 1199;
  var ROW_CLASS = 'lenz-atc-wa-row';

  function getBuyButtons() {
    return document.querySelector('safe-sticky.product-info .product-info__buy-buttons, .product-info .product-info__buy-buttons');
  }

  // El bloque de WhatsApp es el shopify-app-block que sigue al buy-buttons
  // y contiene el botón wa__button del app seedgrow_whatsapp_chat.
  function getWhatsAppBlock(buyBtns) {
    if (!buyBtns) return null;
    var sib = buyBtns.nextElementSibling;
    while (sib) {
      if (sib.classList && sib.classList.contains('shopify-app-block')) {
        if (sib.querySelector('a.wa__button, a[href*="wa.me"]')) return sib;
      }
      sib = sib.nextElementSibling;
    }
    return null;
  }

  function shouldWrap() {
    return window.innerWidth <= WRAP_MAX;
  }

  function wrap() {
    var btn = getBuyButtons();
    if (!btn) return false;
    if (btn.parentElement && btn.parentElement.classList.contains(ROW_CLASS)) return true;
    var wa = getWhatsAppBlock(btn);
    if (!wa) return false;

    var row = document.createElement('div');
    row.className = ROW_CLASS;
    btn.parentNode.insertBefore(row, btn);
    row.appendChild(btn);
    row.appendChild(wa);
    return true;
  }

  function unwrap() {
    var row = document.querySelector('.' + ROW_CLASS);
    if (!row) return;
    var parent = row.parentNode;
    while (row.firstChild) parent.insertBefore(row.firstChild, row);
    parent.removeChild(row);
  }

  function applyLayout() {
    if (shouldWrap()) { wrap(); } else { unwrap(); }
  }

  function init() {
    var tries = 0;
    function attempt() {
      tries++;
      applyLayout();
      if (!shouldWrap()) return;
      if (document.querySelector('.' + ROW_CLASS)) return;
      if (tries < 60) setTimeout(attempt, 500);
    }
    attempt();

    var observer = new MutationObserver(function () {
      if (shouldWrap() && !document.querySelector('.' + ROW_CLASS)) {
        if (wrap()) observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 35000);
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyLayout, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — Header mobile (<740px): vendor / SKU / título / precio
   arriba de la galería.

   Estrategia primaria: el bloque .lenz-mobile-header se renderiza
   en Liquid (main-product.liquid) antes de .lenz-product-left.
   Estrategia secundaria (fallback): si el bloque Liquid no está en
   el DOM (cache de Shopify sirviendo versión anterior), este IIFE
   lo crea dinámicamente desde los datos de product-info.

   Solo actúa en mobile estricto (<740px).
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var MOBILE_MAX = 739; // <740px = mobile estricto

  function run() {
    if (window.innerWidth > MOBILE_MAX) return;

    // Si el bloque Liquid ya está en el DOM, nada que hacer
    if (document.querySelector('.lenz-mobile-header')) return;

    var info   = document.querySelector('safe-sticky.product-info');
    var galería = document.querySelector('.lenz-product-left');
    if (!galería || !galería.parentElement) return;

    var dest = galería.parentElement;  // .product

    // Buscar elementos en todo el DOM
    var vendor = document.querySelector('.product-info__vendor');
    var title  = document.querySelector('.product-info__title');
    var price  = info ? info.querySelector('.product-info__price') : null;

    if (!title && !price) return;

    // Crear el wrapper .lenz-mobile-header
    var header = document.createElement('div');
    header.className = 'lenz-mobile-header';
    dest.insertBefore(header, galería);

    // Mover o clonar elementos dentro del wrapper
    // vendor y title pueden estar ya en .product (movidos por IIFE anterior)
    // o en safe-sticky (si IIFE anterior no corrió)
    function adoptEl(el, wrapperClass, isClone) {
      if (!el) return;
      if (isClone) {
        // Clonar el contenido para no romper reactividad de Shopify
        var div = document.createElement('div');
        div.className = wrapperClass;
        div.innerHTML = el.innerHTML;
        header.appendChild(div);
        el.style.display = 'none'; // ocultar original
      } else {
        // Mover el elemento físico y aplicar clase
        el.classList.add(wrapperClass);
        header.appendChild(el);
      }
    }

    adoptEl(vendor, 'lenz-mobile-header__vendor', true);
    adoptEl(title,  'lenz-mobile-header__title',  true);

    // El precio siempre se mueve (no clona) desde product-info
    if (price) {
      var pDiv = document.createElement('div');
      pDiv.className = 'lenz-mobile-header__price';
      pDiv.innerHTML = price.innerHTML;
      header.appendChild(pDiv);
      price.style.display = 'none';
    }
  }

  // Ejecutar cuando el DOM esté listo
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Re-chequear en load (por si product-info cargó tarde)
  window.addEventListener('load', function() {
    if (!document.querySelector('.lenz-mobile-header') && window.innerWidth <= MOBILE_MAX) {
      run();
    }
  });
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — Badge de descuento dinámico al cambiar variante.

   El custom element on-sale-badge del tema usa el string
   discountBadge ("-@@") al cambiar variante. Lo parcheamos
   para que use la misma lógica condicional del Liquid:
     ≥ 10% → "13% Dcto."
     < 10% → "S/ 20 menos"
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function formatSavings(compareAtPrice, price) {
    var savingsCents = compareAtPrice - price;
    var pct = Math.round(savingsCents * 100 / compareAtPrice);
    if (pct >= 10) {
      return pct + '% Dcto.';
    }
    // Ahorro en soles — usar formatMoney si disponible, fallback manual
    var amount = savingsCents / 100;
    var formatted;
    try {
      formatted = window.Shopify && window.Shopify.formatMoney
        ? window.Shopify.formatMoney(savingsCents, 'S/ {{amount_no_decimals}}')
        : 'S/ ' + Math.round(amount);
    } catch (e) {
      formatted = 'S/ ' + Math.round(amount);
    }
    return formatted + ' menos';
  }

  // Esperar a que on-sale-badge esté definido y parchear connectedCallback
  function patchOnSaleBadge() {
    var proto = window.customElements.get('on-sale-badge');
    if (!proto) return false;
    var origProto = proto.prototype;
    // Parchear el listener de variant:change via observer de eventos
    document.addEventListener('variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      if (!variant) return;
      document.querySelectorAll('on-sale-badge[form]').forEach(function (badge) {
        if (variant.compare_at_price > variant.price) {
          badge.hidden = false;
          badge.textContent = event.detail.product && event.detail.product.price_varies
            ? badge.textContent  // precio variable: no tocar
            : formatSavings(variant.compare_at_price, variant.price);
        } else {
          badge.hidden = true;
        }
      });
    }, true); // capture para correr antes que el listener original
    return true;
  }

  // on-sale-badge puede no estar definido aún al cargar este script
  if (!patchOnSaleBadge()) {
    var checkInterval = setInterval(function () {
      if (patchOnSaleBadge()) clearInterval(checkInterval);
    }, 50);
    setTimeout(function () { clearInterval(checkInterval); }, 5000);
  }
})();

/* ─────────────────────────────────────────────────────────────
   Lenz — Slide 3D inline en mobile: TOMA DE CONTROL TOTAL.

   PROBLEMA: el HTML del snippet product-gallery.liquid está cacheado
   por Shopify por horas. El script inline del snippet también queda
   cacheado, así que cambios en ese código no se reflejan inmediatamente.

   SOLUCIÓN: este IIFE en lenz-product-page-v11.js (que SÍ se actualiza
   inmediatamente vía CDN) toma el control completo del slide 3D:
   1. Lee el slide del DOM (sin importar qué atributo data tenga)
   2. Construye la URL del viewer con minimal=1&v=11 (forzando el modo limpio)
   3. Crea el iframe inmediatamente al cargar (sin lazy load)
   4. Traduce el hint a español si está en inglés
   5. Hace que la galería completa muestre la cámara primero (no el 3D)

   Solo aplica en mobile estricto (<740px).
   ──────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  if (window.innerWidth >= 740) return;

  var VIEWER_VERSION = '11';

  function buildViewerUrl(rawUrl) {
    if (!rawUrl) return null;
    try {
      var u = new URL(rawUrl);
      u.searchParams.set('minimal', '1');
      u.searchParams.set('v', VIEWER_VERSION);
      return u.toString();
    } catch (e) {
      return rawUrl;
    }
  }

  function readSlideSrc(slide) {
    // Probar todos los atributos posibles (el HTML puede estar cacheado con el viejo)
    var candidates = [
      slide.dataset && slide.dataset.viewerUrl,
      slide.getAttribute('data-viewer-url'),
      slide.getAttribute('data-lenz-3d-src'),
      slide.getAttribute('data-lenz3d-src'),
    ];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i]) return candidates[i];
    }
    return null;
  }

  function setupSlide3D() {
    var slide = document.querySelector('.lenz-3d-slide');
    if (!slide) return false;
    if (slide.dataset.lenzSetupDone === '1') return true;

    var rawUrl = readSlideSrc(slide);
    if (!rawUrl) return false;

    var src = buildViewerUrl(rawUrl);
    var container = slide.querySelector('.lenz-3d-slide__iframe-container');
    var skeleton  = slide.querySelector('.lenz-3d-slide__skeleton');
    var hintText  = slide.querySelector('.lenz-3d-slide__hint-text');

    // Crear container si no existe (el HTML viejo puede no tenerlo)
    if (!container) {
      container = document.createElement('div');
      container.className = 'lenz-3d-slide__iframe-container';
      container.style.cssText = 'position:absolute;inset:0;';
      slide.appendChild(container);
    }

    // Traducir el hint si está en inglés
    if (hintText && hintText.textContent.trim() === 'Hold and drag to rotate') {
      hintText.textContent = 'Arrastra para rotar';
    }

    // Fondo blanco al slide (mover el overlay gris a las otras imágenes — ver CSS)
    slide.style.background = '#ffffff';

    // Crear y montar el iframe inmediatamente
    if (!container.querySelector('iframe')) {
      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.className = 'lenz-3d-slide__iframe';
      iframe.allow = 'autoplay; xr-spatial-tracking';
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', 'Vista 3D interactiva');
      iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:none;background:#fff;opacity:0;transition:opacity 0.4s ease;';

      // Mostrar el iframe cuando reciba postMessage 'ready'
      window.addEventListener('message', function onMsg(e) {
        if (!e.data || typeof e.data !== 'object') return;
        var src_ = e.data.source;
        var type_ = e.data.type;
        if ((src_ === 'lenz3d-preload' || src_ === 'lenz3d-custom') && type_ === 'ready') {
          iframe.style.opacity = '1';
          if (skeleton) {
            skeleton.style.opacity = '0';
            setTimeout(function() { if (skeleton.parentElement) skeleton.style.display = 'none'; }, 400);
          }
          window.removeEventListener('message', onMsg);
        }
      });

      // Fallback: mostrar iframe tras 12s aunque no llegue ready
      setTimeout(function() {
        if (iframe.style.opacity !== '1') {
          iframe.style.opacity = '1';
          if (skeleton) {
            skeleton.style.opacity = '0';
            setTimeout(function() { if (skeleton.parentElement) skeleton.style.display = 'none'; }, 400);
          }
        }
      }, 12000);

      container.appendChild(iframe);
    }

    slide.dataset.lenzSetupDone = '1';
    return true;
  }

  // Esperar al carousel y al slide
  function init() {
    if (setupSlide3D()) return;
    var obs = new MutationObserver(function() {
      if (setupSlide3D()) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { obs.disconnect(); }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

